import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { TECHNIQUES } from '../../siteNav';

export default function ExperienceGrid({ intro, title = 'Full', accent = 'Production' }) {
  return (
    <section id="full-production" className="relative bg-black py-24 md:py-32" data-testid="technique-grid">
      <div className="max-w-[1500px] mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <h2 className="font-display text-[#f4efe6] uppercase text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tight">
            {title} <span className="font-script text-[#00b8ff] normal-case italic">{accent}</span>
          </h2>
          <p className="text-[#cfc8bb] text-base md:text-lg max-w-md">
            {intro || 'End-to-end production for tours, drops, and brand activations. Concept, design, manufacturing, on-site execution \u2014 we handle every step so you can focus on the moment.'}
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
          {TECHNIQUES.map((t) => (
            <Link
              key={t.slug}
              to={`/production/${t.slug}`}
              className="group relative aspect-[3/4] overflow-hidden rounded-md"
              data-testid={`technique-tile-${t.slug}`}
            >
              <img src={t.img} alt={t.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent pointer-events-none" />
              <ArrowUpRight className="absolute top-4 right-4 w-5 h-5 text-[#f4efe6] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute inset-x-0 bottom-0 p-5 pointer-events-none">
                <p className="font-display text-[#f4efe6] uppercase text-xl md:text-2xl tracking-tight leading-tight">{t.name}</p>
                <div className="h-[2px] w-0 bg-[#00b8ff] mt-2 transition-all duration-500 group-hover:w-12" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
